module.exports = __webpack_public_path__ + "media/pro/edit-details@2x-ac613a88.png";